import { render, staticRenderFns } from "./1.vue?vue&type=template&id=ca31d47e&scoped=true&"
import script from "./1.vue?vue&type=script&lang=ts&"
export * from "./1.vue?vue&type=script&lang=ts&"
import style0 from "./1.vue?vue&type=style&index=0&id=ca31d47e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca31d47e",
  null
  
)

export default component.exports